import Logo from '../assets/img/logo_light.svg';

const Header = () => {
  return (
    <header className="App-header">
      <img src={Logo} alt='brainyx' width='350' height='55' />
    </header>
  );
}
export default Header;